export const lovelettercontents = [
  {
    title: "Letter 1",
    description:
      "This is the first letter I wrote for you, darling! Just relax and keep your expectation low!",
    image: "/images/letter/letter1.jpg",
    content: `To Mint,
  
      I’m writing this letter at the airport right now. By the time you read this letter, it means that we are already together. Thank you for coming into my life, darling.
      
      I am so happy just for the fact that you are now my girlfriend. Trust in me! I would never take you for granted. I am a little bit worried about our compatibility in the next couple weeks. This is the first time I’m being a boyfriend to someone. So go easy on me! That being said I hope the next few weeks of us will go smoothly.
      
      You know what, falling in love with you is something that was not in my plan. But now it’s something I want to do. Thinking about meeting you makes my heart skip a beat.
      
      I don't really know what it means to love someone “correctly”. But in this 3-week long period, I want to become the best man I could just for you. This I promise you, darling.
      
      I love you. Always have.
      
      Henry
      
      P/s: One thing about me is I always keep some writing papers in my bag so that I can write my letters at any time. I was thinking of handing the 1st letter to you sooner but since you hate my handwriting. Finally, I decided to make this website so I can avoid writing, which makes my life 100% harder. Pretty silly, isn’t it?`,
  },
  {
    title: "Letter 2",
    content: `To Mint,
    
        When you read this letter, I would be at the airport right now? Maybe, I don't know. It looks like you are moody tonight and kicks me out of the room again. That's why I've decided to write this letter before I take off tomorrow.
        
        The three-week period has been a short time for us. It's February already. That's why I'm actually feeling a little nervous just now. What will we do if we don't recognise each other when we meet again? It doesn’t matter much because no matter how much I try to imagine what you look like in casual or sexy clothes, you always are a beauty to me.
        
        Hmmm, what else should I write? Oh, I know. I will start by giving my thanks. I will write down the feelings I had for you that I couldn't convey properly. When I first saw you in real life I was really glad you were there. I was happy we got along pretty well. If you weren't hugging me when I was there, I couldn't imagine what horrible things could have gone wrong. Thank you, darling!
        
        That's why I really didn't want to part with you. Because every day of my life, I would think to myself many times, "How much better would it be if you were here?"
        
        I'm very sad that you are thousands of kilometers away from me. Even though we're separated in between Vancouver and Edmonton, I have always thought to myself that, "She is within my reach." I could always have taken the plane right away to go see you. But this time, going to the other side of Canada is a bit too far for me. From now on, I will have to learn how to live well by myself without your physical existence and I know you have to do the same. I know you can do it. Both you and I have to.
        
        There's another thing that I must tell you. I'm writing this down in this letter just in case I can't say it out loud to you. I love you.
        
        I can't remember when I fell in love with you but very naturally, I had fallen in love with you before I knew it.
        
        Darling, I'm sure you will be alright. No matter what happens, I know you will grow up to be a fine woman. No matter how far you go, I will always love you.
        
        Please, please remember that.
        
        Your love,
        
        Henry
        `,
    description:
      "Second letter I wrote for you, baby! There are more things for me to say...",
    image: "/images/letter/letter2.jpg",
  },
  {
    title: "Letter 3",
    content: `To Mint,
    
        When you read this letter, I would be on my way to Vancouver by now. I know this for sure because it's how the code is set up. I'm writing this letter to let you know that you are very special for me.
        
        It's been 3 months since the last time we were together. I'm actually feeling a little of uncertainty right now. I'm not sure if I'm ready for this move. But... one thing I do know is I want to be there with you!
        
        I want to thank you for listening to me everyday. I want to thank you for growing more matured everyday. I want to thank you for putting effort into learning to become a good cook. I want to thank you for spending time on learning to play the piano. And finally, I want to thank you for working hard to become an more awesome girlfriend everyday.
        
        I hope that we will never stop growing together. I see a future in you and I hope you see a future in me too.
        
        Mint, I will always love you. See you soon, darling.
        
        Your love,
        
        Henry
        `,
    description: `Don't be too surprised! Keep your expectation low! Remember
        that I will always love you!`,
    image: "/images/letter/letter3.jpg",
  },
  {
    title: "Letter 4",
    content: `To Mint,
    
        I had a long day yesterday. I could not sleep last night. There are still a lot of work left to do, but I couldn't think about it anymore. My mind started wandering, and then I think of you. It eases my mind whenever I think of you. And I'm afraid of facing you right now. But whatever happened, I will hold you tight in my arms and show you how much I love you.
        
        I remembered the day we first met. We were shivering while hugging each other in the cold weather. I still remember the misheard lyrics, out-of-tune singings you sang everyday. I remember how you always try your best to cook your best breakfasts for me. I really appreciate it a lot, baby.
        
        It's only a couple hours more before I see you again. Thinking about that makes me a little bit happy but also worried. But one thing for sure is we will be together again!
        
        One thing you should keep in your heart is that I will always love you!
        
        Your love,
        
        Henry
        `,
    description: `And I will always love you... will always love
        you..ouuuuu.....`,
    image: "/images/letter/letter4.jpg",
  },
  {
    title: "Letter 0.0",
    content: `Gửi Mint,
    
        Anh muốn nói với em là anh muốn chúng ta có thể yêu nhau lại từ đầu.

        Anh muốn em nấu ăn sáng cho anh mỗi ngày, đó là niềm phúc đầu tiên hàng ngày của anh

        Anh muốn em không chỉ là một người phụ nữ xinh đẹp mà còn giỏi giang, khiến anh cảm thấy hãnh diện với mọi người

        Anh muốn có một ngôi nhà nhỏ bé với một vườn cây bé bé xinh xinh do anh và em chăm sóc

        Anh muốn có một cái xích đu nho nhỏ để hàng ngày anh có thể ngồi xích đu và đọc sách với em, đưa xích đu cho em

        Anh muốn có một hai đứa bé xinh xinh, để anh có thể nhìn chúng lớn dần lên, nhìn em nắm tay bàn tay bé con và dỗ dành nó khi nó bĩu môi giận dỗi
        
        Anh muốn chúng ta có những ngày thanh bình chỉ nói chuyện với nhau bằng ánh mắt cũng đủ rồi

        Những ngày chỉ cần tựa vào nhau cũng thấy lòng thanh thản

        Những ngày buồn chán như con gián, ít gió nhiều mây nhưng ta vẫn bên nhau

        Những ngày vui vẻ hạnh phúc, đầy nói cười yêu thương

        Những ngày giận dỗi tổn thương nhưng vẫn động viên an ủi nhau

        Những ngày đau khổ cô đơn nhưng vẫn biết cách cho nhau không gian riêng để healing

        Những ngày chỉ muốn ôm em thật chặt không làm gì cả

        Những ngày bực bội mệt mỏi chỉ muốn ở một mình

        Những ngày ốm đau được nửa kia tận tình chăm sóc

        Những ngày mất mát có thể tựa vào vai nhau, ôm nhau khóc

        Chúng ta đã đi qua thương nhớ và sẽ còn tiếp tục đi qua thương nhớ trong thời gian tới

        Nếu em muốn hạnh phúc trở lại thì anh cũng sẽ cho mình một cơ hội để có thể hạnh phúc ở bên em
        
        Em có muốn chính thức trở thành bạn gái của anh kể từ hôm nay không?
        
        Henry
        `,
    description: `I want to love you again!`,
    image: "/images/letter/letter5.jpg",
  },
  {
    title: "Letter 0.1",
    description: "Two letters in a day, lucky you!",
    image: "/images/letter/letter6.jpg",
    content: `To Mint,

      This recording is not perfect just like your recording, just like the two of us. We are not perfect. You make mistakes, I make mistakes. But I believe if we work together, we can be better as a whole.
      
      After all thoughts, I thought I did pity you for the first 2 weeks after we broke up. But I have thought things through. I realized I do love you just the way you are, no more no less. We are human after all, we make mistakes and we correct them. I don't believe "once a cheater, always a cheater". I hope my judgements about you will be correct in the future regardless of whether we are still together or not!
      
      Believe me, I love you.

      Henry

      P/s: I hope you are doing well. I will be waiting for your reply. No matter what your decision is, I will be here for you.


      `,
    video: `https://www.youtube.com/embed/27Fv5ATYLY0`,
  },
  {
    title: "Letter 0.2",
    description: "It's now or never!",
    image: "/images/letter/letter7.jpg",
    content: `Gửi Mint,

    Tại sao, tại sao anh lại nói câu Anh Yêu Em khi mà chính anh còn không chắc là có phải anh yêu em không? 
    Bởi vì vẫn còn yêu em, anh chỉ không chắc là sẽ có thể mãi yêu em nếu mọi thứ bế tắc như hiện tại.
    
    Tại sao, tại sao anh lại quan tâm, chăm sóc cho em khi mà anh nghĩ đến việc rời bỏ em? 
    Bởi vì anh lo lắng cho em, anh vẫn muốn yêu em trọn vẹn.
    
    Tại sao, tại sao anh lại nói đến tương lại, muốn có baby, muốn chờ có 100k rôi có baby? 
    Bởi vì anh vẫn nghĩ là chúng ta sẽ có một tương lai, một mái ấm với nhau.
    
    Tại sao, tại sao anh lại có thể masturbate cùng em khi mà anh không chắc là anh con yêu em không? 
    Bởi vì hạn chế coi pornography, nên anh chỉ có thể release với em thôi. Anh muốn cho em thấy là anh không hề nghĩ đến have sex với người khác. Việc have sex đối với anh đôi khi không phải để thể hiện tình yêu mà để xả stress, có thể em sẽ hụt hẫng khi biết nhưng đa phần đàn ông có thể have sex mặc dù không yêu thương ai đó nhưng phụ nữ thì ngược lại. Anh hỏi hai ông bà chuyện sex như thế nào, họ bảo ban đầu thì còn mới mẻ, nhưng 3-5 năm thì cũng bình thường, giờ thì chắc 1-2 lần 1 năm. Nhưng họ nói ở với nhau chỉ vì sex thì đừng nghĩ đến yêu nữa, còn rất nhiều thứ khác trong cuộc sống hôn nhân.
    
    Có phải là tại vì anh cảm thấy có lỗi hay cảm thấy thương hại em khi mà anh nhìn thấy em cố gắng từng ngày từng ngày một mà nên anh muốn cho em một chút hy vọng để em cố gắng tiếp? 
    Bởi vì anh vẫn muốn yêu em trọn vẹn, anh chỉ cảm thấy em rất ngây thơ những tuần đầu sau breakup, khi ta nói chuyện nhiều về những cách đối xử của em với người khác. Anh cũng chỉ nghĩ là sẽ lo cho em một thời gian thôi nhưng rồi những hành động của em lay động anh.

    Tại sao chỉ vi một cái Yes từ một người lạ, mới có thể khiến anh có động lực muốn yêu em trở lại vậy? 
    Bởi vì con người lí trí của anh không cho phép anh yêu em, nhưng một cái 'Yes' mang ý nghĩa rất lớn đối với anh. Nó cho phép con người lí trí của anh có thể tin vào xác suất có thể xảy ra. Dù là nhỏ cỡ nào, nhưng anh vẫn có thể tin vào xác suất có thể xảy ra. Nếu xác suất bằng không thì làm sao mà con người lí trí anh có thể cân đong đo đếm được. Vấn đề là ở anh nên em cũng không cần phải tự hỏi mình, anh biết là em yêu anh nhưng anh phải thống nhất con tim lí trí anh đã.

    Em ghét con người của em, có thể dễ dàng mít ươt đến như vậy. Em yếu đuối, đau khổ cũng chỉ biết khóc một mình. Vì anh nói mỗi lần nhìn thấy em khóc, kí ức xấu lại ùa về. Đến cả khóc thôi em cũng không được khóc nữa, đừng nói đến việc được người mình thương an ủi. Em cũng không dám buồn mặc dù em cảm thấy rất tồi tệ trước mặt anh vi em sợ anh sẽ không muốn ở bên một người lúc nào cũng chỉ buồn bã, mít ướt. Anh bị attracted bởi những cô gái vui vẻ hay mang lại tiếng cười. Em xin lỗi, em không thể trở thành con ngươi mà anh muốn được, em chỉ có thể trở thành người tốt hơn thôi.
    
    Cám ơn bạn đã cố gắng vì mình. I told you I love you just the way you are. Việc attracted bởi ai đó là chuyện bình thường, và mình từng attracted bởi bạn vì điều đó là bình thường. Mình chỉ giải thích tại sao mình bị attracted bởi bạn thôi. Nhưng không có nghĩa là attracted là sẽ hợp với nhau. Còn cả một đống vấn đề liên quan: quan điểm, văn hóa, chính trị, gia đình, tài chính, con cái, giáo dục, tình dục,... Tại sao bạn lại sợ hãi khi nghĩ mình bị attracted bởi người khác? Còn rất nhiều điều mình đã share với bạn mà người khác không hề có được. Building up a relationship takes a lot of effort, not a story of a month or two.

    Em càng đau khổ hơn nữa, khi anh đã dàn dựng được chi tiết plan khi mà anh sẽ nói chia tay em. 

    Anh cho em đọc tính cách của anh mà cũng như không. Em không hiểu anh. Anh giỏi lên kế hoạch nên mọi sự anh đều lường trước. Em muốn anh cởi mở nên anh cũng cởi mở nói cho em biết. Nói cho em biết kế hoạch không có nghĩa là anh sẽ thực hiện kế hoạch ấy. Nó chỉ cho em thấy là anh tin tưởng để nói cho em biết các kế hoạch xảy ra như thế nào và anh muốn feedback từ em. Nhưng em lại nghĩ là anh muốn chia tay em. Anh không nói với anh mà lại đi nói với Duckie, em có thật sự tin tưởng anh không?

    Có phải em đang manipulate anh không? Làm anh không thể decisive? Có thể. Anh không biết. Anh chỉ biết em thật lòng muốn yêu anh.

    Tại sao em lại cảm thấy trống rỗng như này? Có phải là em đang reasoning quá nhiều không? Em không biết. Em không depressed, không cảm thấy overwhelmed, cũng không cảm thấy hoang mang. Em chỉ là trống rỗng không thể nghĩ được là sẽ dừng lại hay đi tiếp.
    
    Tại vì bạn overthinking nhiều quá bạn có biết không? Bạn lây cho mình cái tính indecisive. Giờ bạn kiếm một đồng xu bạn tung đi. Mặt hình là ở, số là đi. Không phải để coi hình với số, mà trong khoảnh khắc trước khi mở ra, bạn mong mặt nào thì cứ chọn mặt ấy.

    Em không tin vào cái gội là meant to belong together. Làm gì có chuyện take break 6m-1y lại có thể quay trở lại yêu được nhau nữa cơ chứ. Không có tình yêu nào là không tốn công sức và cố gắng để dựng xây được. Làm gì có chuyện take break 6m-1y lại có thể quay trở lại yêu được nhau nữa cơ chứ. Không có tình yêu nào là không tốn công sức và cố gắng để dựng xây được. Remember? Chính anh nói, chính anh cảm thấy anh đang dần xa lánh em mặc dù ngày nào em và anh cũng video call cùng nhau, mặc cho em có thể hiện tình yêu thương của mình nhiều đến thế nào.
    
    Anh cũng không nghĩ là 6 tháng sau anh có thể tiếp tục yêu em nữa. Bản chất anh thích chắc chắn. Đó là lí do anh mới quyết định nói ra những gì anh muốn làm với em. Anh nói ra để em biết là anh cần những gì và anh muốn thấy được một kế hoạch rõ ràng để thực hiện nó. Vì những kế hoạch mà em đưa ra chỉ có em trong đó thôi, nó bao gồm việc em sẽ chủ động như thế nào, muốn làm sao. Anh không phải là một nhân tố trong kế hoạch đó của em. Anh cảm nhận như anh chỉ là một phần thưởng, một điều gì đó em muốn đạt được chứ không phải vì em muốn chúng ta đi cùng nhau. Cũng có thể là anh quá khắt khe vì anh muốn kế hoạch rõ ràng chi tiết nhưng em lại không làm được mà anh cũng không nói cho em biết kì vọng của anh.

    Suy nghĩ cho kĩ rồi muốn hỏi gì thì hỏi. Anh cho em thời gian để Q&A.

    Nếu không nghĩ được thì gọi cho anh.

    Anh chờ em,

    Henry

    P/S: Mình chả cấm bạn khóc bao giờ cả, mình chỉ muốn dỗ bạn nín để tâm trạng bạn tốt thôi. Nếu bạn muốn khóc thì bạn cứ điện cho mình, để mình cho bạn khóc thoải mái, kiềm chế làm gì. Stress chết queo các bạn ơi, bạn đòi mình express yourself mà bạn hold back là sao?
     
    `,
    video: `https://www.youtube.com/embed/XLMu3CEwlcI`,
  },
  {
    title: "Letter 0.3",
    description: "This is the 8th letter I wrote for you, darling!",
    image: "/images/letter/letter8.gif",
    content: `To Mint,  
      
      It's been more than 3 months since the last time we saw each other in person. I have been missing you everyday but I don't know if my feelings are conveyed to you so that you can understand. I know you have been working hard in the past couple months. Please continue the good work you have been doing. I'm very proud of you when I see you grow everyday. 
      
      It must been hard for you being there alone without my warm embrace. Don't be discouraged, be strong! You are much more capable than you think. You just need to be patient and endure the hardship in the time being. Time is on your side. And I am on your side. Tomorrow may be a hard time but your future will definitely be a good time.

      I love you. Always have.
      
      Henry
      `,
    video: `https://www.youtube.com/embed/iFQbE2gRz_w`,
  },
  {
    title: "Letter 0.4",
    description: "One small step for Mint, one giant leap for our future!",
    image: "/images/letter/letter9.jpg",
    content: `Gửi tình yêu của anh,  
      
      Cảm ơn em vì đã mua đồ ăn cho anh. Dù nó chỉ là một bữa ăn nho nhỏ nhưng đối với anh nói là một điều rất to lớn.

      Nó chứng minh là em đã biết trưởng thành hơn. Tháng lương đầu tiên chưa nhận mà đã mua cho anh rồi. 
      
      Anh rất cảm động khi nhìn em trưởng thành mỗi ngày. Anh cảm thấy em đang làm việc nhiều hơn, đừng lo lắng vì anh sẽ luôn support em. 

      Cảm ơn em vì mọi thứ. Yêu em nhiều nhiều.
      
      Henry

      P/s: anh luôn muốn nhìn thấy em cười mỗi ngày, nên dù có trưởng thành thì hãy giữ lại cho anh Mint hồn nhiên, khùng khùng, điên điên nhé.
      `,
    video: `https://www.youtube.com/embed/Z7tiB0xMrZg`,
  },
  {
    title: "Letter 0.5",
    description: "Happy birthday!",
    image: "/images/letter/letter10.gif",
    content: `To: Mint, my love

I plan to give you an affectionate greeting with a spank in the ass when I see you, but before that I wanted to advance my words and go on wishing you a very happy birthday.

I would never forget this day because it is the day that you come to this world. Thanks to a day like this, I can smile so much because you are the source of all my joy.

You are the one who compliments my life and who motivates me to keep going. You renew my hopes and my strength every time I fall, and you make the good times end up being perfect.

Today on your birthday, I would like to give you my $100 of my hard-earned money, which is a small treat that I offer for you, but I cannot because I already gave it to you the day 2 weeks ago.

Of the man who loves you unconditionally,

Henry

`,
    video: `https://www.youtube.com/embed/QgaTQ5-XfMM`,
  },
  {
    title: "Letter 0.6",
    description: "You can do it!",
    image: "/images/letter/letter11.jpg",
    content: `To: Mint, my baby

I know you are having a hard time lately with your job. But I want to remind you that I'm here to listen and support you every step of the way.

I want to make you feel comfortable and to make you feel like you deserve better opportunites. I want to make you feel like you are in control of your own life.

I think you are doing a great job and you are capable of great things. But great people need help sometimes, so don't be afraid to ask for help.

I will always be there for you.

Henry

`,
    video: `https://www.youtube.com/embed/YXuB6md9zPk`,
  },
  {
    title: "Letter 0.7",
    description: "For Mint dam dang!",
    image: "/images/letter/letter12.gif",
    content: `My love,

    I wish I am there with you because it’s lonely being here without you. I’ve tried to do so many things, but it keeps hitting me deep in my heart that I am missing someone so precious. The distance is killing me because the ache of missing you. Sometimes I still have nightmares losing you forever from my life. 

I know you’re striving for a better future. I want the best for you too, but if I have my way, I’d be right there by your side like your favorite heater.I’ll show you how much I want to hug-hug you. I’ll give you my warm embrace esspecially just for you.

I want kiss your soft lips. I want to be the best for you so we will have a bright and fantastic future together. I love you with all that I am, all that I was and all that I will ever be.

Henry

`,
    video: `https://www.youtube.com/embed/1PlnnWHxbrM?start=3`,
  },
  {
    title: "Letter 0.8",
    description: "Happy New Year!!",
    image: "/images/letter/letter13.jpg",
    content: `My dearest Minto,

    As the new year begins, I wanted to take a moment to reflect on our relationship and express my desire for us to grow and mature together. I care deeply about you and want nothing more than for us to be happy and healthy as a couple.

One of the things that I value in our relationship is emotional stability and maturity. I know that we have both faced challenges and hardships, but I believe that by working together and supporting each other, we can become stronger and more resilient. I am here for you, and I want to help you grow and develop in any way that I can.

I am grateful for all that you bring to our relationship and I am looking forward to building a bright and positive future together. Let's make this year one of growth, love, and happiness.

With love and appreciation,

Henry

P/S: I want to use the wish ticket for one thing: we will spend at least 2hr a week to practice mindfulness together. It could be meditation. It could be listening to mindfulness podcasts. The important thing is you and I can explore new ways to find balance and peace in our lives.

Here is a bonus video about mindfulness for you to watch. I hope you enjoy it:
`,
    video: `https://www.youtube.com/embed/-gqYRqPYCoo?start=218`,
  },
  {
    title: "Letter 0.9",
    description: "For Mint Adult!",
    image: "/images/letter/letter13.gif",
    content: `Gửi Minto,

    Chào Minto xinh xắn đáng yêu của anh hengi. Anh hengi có một điều trong lòng muốn nói cho các bạn biết mà khá là lâu anh hengi vẫn phải giữ trong lòng. Vấn đề financial support cho Mint.

    Anh hengi rất quan tâm và muốn chăm sóc cho Mint nhiều nhất có thể. Nhưng mà, anh hengi nhận ra là anh hengi không thể tập cho Mint thói quen manipulate anh hengi hoài được. Anh hengi biết là Mint cũng có nhu cầu tài chính của mình, nhưng anh hengi cũng có financial reponsibilities và anh hengi phải prioritize mục tiêu của mình.

    Anh hengi biết là Mint sẽ không thích nghe, anh hengi cũng không muốn Mint cảm thấy như anh hengi không muốn support Mint. Nhưng không phải vậy, anh hengi vẫn muốn ở bên Mint để support cho Mint những lúc cần. Nhưng, anh hengi muốn set boundaries for myself.
    
    Hôm nay là lần cuối anh hengi cho Mint manipulate anh hengi, anh hengi sẽ cho Mint thêm 6 tháng tiền măm măm support. Anh hengi hi vọng sẽ có một ngày nào đó Mint sẽ hiểu và cảm ơn anh hengi. Nếu Mint có ý kiến, anh hengi sẽ lắng nghe và tìm cách giải quyết cho Mint.

    Yêu yêu thương thương Mint,

    Henry

`,
    video: `https://www.youtube.com/embed/bMqoq6yzNnE`,
  },
  {
    title: "Letter 0.9.1",
    content: `Gửi Minto,
    
        Anh Hengi muốn nói với Mint là anh Hengi rất bực mình và thất vọng với những hành động gần đây của Mint. Anh Hengi cảm thấy Mint đang lơ là anh Hengi, Mint ngày càng nghiện ngập social media.

        Anh Hengi biết là Mint thích coi social media để giải trí cho qua thời gian, nhưng anh Hengi cảm thấy nó đang lấy dần thời gian của anh Hengi ở bên Mint. Anh hengi cảm thấy anh Hengi phải compete với cái điện thoại của Mint để Mint chú ý. Có vẻ như lúc nào Mint cũng đang ở thế giới khác mà anh Hengi không nằm trong thế giới đó.

        Việc Mint prioritize social media hơn là dành thời gian cho anh Hengi khiến anh Hengi cảm thấy rất buồn. Có vẻ như Mint đang xa cách anh Hengi, và anh Hengi không muốn điều đó xảy ra. Mint quan trọng với anh Hengi và anh Hengi trân trọng thời gian chúng ta dành cho nhau. Từ lâu rồi anh Hengi không còn nghe những deep conversations với Mint. Mint deep thoughts ngay xưa đâu rồi?

        Anh Hengi ko yêu cầu Mint từ bỏ social media, nhưng anh Hengi muốn Mint hãy respect anh Hengi hơn. Anh Hengi muốn Mint focus on building a better relationship with anh Hengi. Chúng ta có thể kiếm những hoạt động khác mà 2 người đều thích, nói chuyện nhìu hơn, khám phá những thứ có thẻ làm cho chúng ta cảm thấy hạnh phúc. Anh Hengi muốn Mint hãy tập trung vào những điều đó hơn là social media.

        Rome is not built in one day. Relationship needs maintenance and effort. Anh hengi hi vọng là Mint sẽ hiểu để chúng ta có thể lại cười đùa với nhau một ngày nào đó.

        Anh hengi care for Mint, so let's put down the phone and spend some time together.

        Yêu yêu thương thương Mint,

        Henry
        `,
    description: `Please put down your phone and spend some time with me.`,
    image: "/images/letter/letter14.gif",
  },
  {
    title: "Letter 0.9.2",
    content: `Gửi Minto,
    
        Anh Hengi muốn đề cập đến vấn đề các bạn lấy thẻ mastercard của anh Hengi. Anh hengi rất thất vọng vì bạn lấy thẻ của anh hengi mà không có sự đồng ý của anh Hengi. Anh hengi tin là bất kì quyết định nào, nhất là quyết định tài chính phải dựa trên sự đồng ý và tin tưởng lẫn nhau. 

        Tài khoản mastercard của anh hengi không phải chỉ để trả lặt vặt mà còn dùng để trả tiền bill cho công ty và những dịch vụ khác. Việc chiếm dụng tài khoản này mà không có sự đồng ý của anh hengi là vi phạm pháp luật. Anh hengi không muốn các bạn phải đối mặt với những hậu quả pháp lý trong tương lai.
        
        Để tránh hiểu lầm trong tương lai, anh hengi đề xuất mở joint bank account. Đây là account các bạn có thể cầm để làm những việc chung khi cần. Nó cũng tạo nên sự công khai minh bạch cho các bạn và anh hengi.

        Đây không phải là vấn đề nhỏ, anh hengi muốn các bạn hiểu và cùng nhau giải quyết vấn đề này. Việc này đòi hỏi honesty, trust and open communication. Anh hengi cũng muốn thiết lập clear rules and boundaries cho joint bank account, khi nào thì nên sử dụng tài khoản này.
        
        Anh hengi các bạn take it seriously. Anh hengi mong có thể giải quyết vấn đề này trước khi anh hengi gặp lại các bạn.
        
        Anh hengi tin là các bạn có thể làm được. 
        
        Yêu yêu thương thương Mint,

        Henry
        `,
    description: `Towards Financial Trust: A Joint Account Proposal`,
    image: "/images/letter/15.gif",
  },
];
